// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Linkedin: React.FC<{ width?: number; height?: number }> = ({ width = 25, height = 25 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 25 25">
            <path
                fill="currentColor"
                d="M23.2142857,0 L1.78571429,0 C0.78125,0 0,0.837053571 0,1.78571429 L0,23.2142857 C0,24.21875 0.78125,25 1.78571429,25 L23.2142857,25 C24.21875,25 25,24.21875 25,23.2142857 L25,1.78571429 C25,0.837053571 24.21875,0 23.2142857,0 Z M7.53348214,21.4285714 L3.85044643,21.4285714 L3.85044643,9.48660714 L7.58928571,9.48660714 L7.58928571,21.4285714 L7.53348214,21.4285714 Z M5.69196429,3.57142857 C6.86383929,3.57142857 7.86830357,4.52008929 7.86830357,5.74776786 C7.86830357,6.91964286 6.86383929,7.86830357 5.69196429,7.86830357 C4.52008929,7.86830357 3.57142857,6.91964286 3.57142857,5.74776786 C3.57142857,4.52008929 4.52008929,3.57142857 5.69196429,3.57142857 Z M21.4285714,21.4285714 L17.7455357,21.4285714 L17.7455357,15.625 C17.7455357,14.2299107 17.6897321,12.4441964 15.7924107,12.4441964 C13.8950893,12.4441964 13.6160714,13.9508929 13.6160714,15.5133929 L13.6160714,21.4285714 L9.87723214,21.4285714 L9.87723214,9.48660714 L13.4486607,9.48660714 L13.4486607,11.1049107 L13.5044643,11.1049107 C14.0066964,10.2120536 15.1785714,9.20758929 17.0200893,9.20758929 C20.7589286,9.20758929 21.4285714,11.6629464 21.4285714,14.8995536 L21.4285714,21.4285714 Z"
            />
        </svg>
    );
};

export default React.memo(Linkedin);
